import "./styles/estilosGlobais.scss";
import PaginaInicial from "./paginas/paginasInicial";

export default function App() {
  return <PaginaInicial />;
}
